import * as React from 'react';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */

var ExpansionPanelContext = React.createContext({});

if (process.env.NODE_ENV !== 'production') {
  ExpansionPanelContext.displayName = 'ExpansionPanelContext';
}

export default ExpansionPanelContext;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/ExpansionPanel/ExpansionPanelContext.js
// module id = 824
// module chunks = 2